// /v3/analytics/network/:stationId/plays?userId=203825

import { DateRange } from '../../../Date/types';
import { getApiUrl } from '../../../Url';

const QUERY_KIND = 'totalRevenue';

export type NetworkTotalRevenueParameters = DateRange & {
  webStationId: string;
  userId: number;
  timeInterval?: number;
};

export type NetworkTotalRevenueResponse = {
  stationId: number;
  podcastNetwork: string;
  kind: 'totalRevenue';
  parameters: {
    timeRange: number[];
    timeInterval: number;
  };
  data: {
    rows: [number, number][];
  };
  columnHeader: [
    {
      name: 'Time (UTC)';
      type: 'integer';
    },
    { name: 'Plays'; type: 'integer' }
  ];
};

export async function fetchNetworkTotalRevenue({
  webStationId,
  userId,
  startDateRange,
  endDateRange,
  timeInterval,
}: NetworkTotalRevenueParameters): Promise<NetworkTotalRevenueResponse> {
  try {
    const response = await fetch(
      getNetworkToalRevenueUrl({
        webStationId,
        userId,
        startDateRange,
        endDateRange,
        timeInterval,
      }),
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );
    if (response.ok) {
      return await response.json();
    }
    throw new Error(`Could not fetch this network's total plays`);
  } catch (err) {
    throw new Error(err.message);
  }
}

export function getNetworkToalRevenueUrl({
  webStationId,
  userId,
  startDateRange,
  endDateRange,
  csvFilename,
  timeInterval,
}: NetworkTotalRevenueParameters & {
  csvFilename?: string;
}) {
  return getApiUrl({
    path: `analytics/network/:webStationId:${webStationId}/${QUERY_KIND}`,
    queryParameters: {
      userId,
      startDateRange,
      endDateRange,
      csvFilename,
      timeInterval,
    },
  });
}
